import { render, staticRenderFns } from "./goodsDetails.vue?vue&type=template&id=4b757a92&scoped=true&"
import script from "./goodsDetails.vue?vue&type=script&lang=js&"
export * from "./goodsDetails.vue?vue&type=script&lang=js&"
import style0 from "./goodsDetails.vue?vue&type=style&index=0&id=4b757a92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b757a92",
  null
  
)

export default component.exports